<template>
  <div class="dapp-statistics">

    <slot></slot>

    <div class="row">

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.user1d') }}</div>
        <div>{{ intValue(dapp.user1d) }}</div>
      </div>

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.tx1d') }}</div>
        <div>{{ intValue(dapp.tx1d) }}</div>
      </div>

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.value1d') }}</div>
        <div>{{ decimalValue(dapp.value1d) }}</div>
      </div>

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.user7d') }}</div>
        <div>{{ intValue(dapp.user7d) }}</div>
      </div>

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.tx7d') }}</div>
        <div>{{ intValue(dapp.tx7d) }}</div>
      </div>

      <div class="statistics-item col-4 col-lg-2">
        <div>{{ $t('column.value7d') }}</div>
        <div>{{ decimalValue(dapp.value7d) }}</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'DAppStatistics',
    props: ['dapp'],
    methods: {
      intValue (value) {
        return value || 0
      },
      decimalValue (value) {
        return (value && value.toFixed(4)) || 0
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../utils";

  .statistics-item {
    text-align: center;
    padding: 5px;
    margin: 8px 0;
    > *:first-child {
      color: #999999;
      margin-bottom: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppStatistics.vue